import { render, staticRenderFns } from "./PluginIndex.vue?vue&type=template&id=452b9294"
import script from "./PluginIndex.vue?vue&type=script&lang=js"
export * from "./PluginIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports